/**
 * Workflows Module Routes
 *
 * Route definitions for the Workflows module.
 * All routes are admin-only and wrapped in ModuleLayout.
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/workflows',
        component: ModuleLayout,
        meta: {
            moduleKey: 'settings.workflows',
        },
        children: [
            {
                path: '',
                name: 'workflows-list',
                component: () => import('./views/WorkflowList.vue'),
                meta: {
                    title: 'Workflows',
                },
            },
            {
                path: 'create',
                name: 'workflows-create',
                component: () => import('./views/WorkflowForm.vue'),
                meta: {
                    title: 'Create Workflow',
                },
            },
            {
                path: 'dead-letter',
                name: 'workflows-dead-letter',
                component: () => import('./views/DeadLetterList.vue'),
                meta: {
                    title: 'Dead Letter Queue',
                },
            },
            {
                path: ':id',
                name: 'workflows-detail',
                component: () => import('./views/WorkflowDetail.vue'),
                meta: {
                    title: 'Workflow Detail',
                },
            },
            {
                path: ':id/edit',
                name: 'workflows-edit',
                component: () => import('./views/WorkflowForm.vue'),
                meta: {
                    title: 'Edit Workflow',
                },
            },
            {
                path: 'executions/:executionId',
                name: 'workflows-execution-detail',
                component: () => import('./views/ExecutionDetail.vue'),
                meta: {
                    title: 'Execution Detail',
                },
            },
        ],
    },
]

export default routes
